import * as React from "react";

;
export const InfoBasic = (props: React.SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}><path fill="#100722" d="M10.912 20h2.184V9.19h-2.184V20Zm-.346-14.651c0 .805.621 1.426 1.426 1.426.805 0 1.45-.621 1.45-1.426 0-.805-.645-1.449-1.45-1.449-.805 0-1.426.644-1.426 1.449Z" /></svg>;